<template>
	<div class="system-confirm">
		<van-action-sheet
			v-model="visible"
			cancel-text="取消"
			close-on-click-action
			@cancel="onCancel"
		>
			<div class="content">
				<p  class="content-text">{{ text }}</p>
				<button  type="button" class="content-btn confirm" @click="onConfirm">确定</button>
			</div>
		</van-action-sheet>
	</div>
</template>

<script>
	export default {
		name: 'SystemConfirm',
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			text: {
				type: String,
				default: '确认删除？'
			}
		},
		data() {
			return {};
		},
		computed: {
			visible:{
				get() {
					return this.show
				},
				set(val) {
					this.$emit('update:show', val); //触发 input 事件，并传入新值
				}
			}
		},
		methods: {
			onCancel() {
				console.log('取消');
				this.$emit('update:show', false); //触发 input 事件，并传入新值
				this.$emit('handleCancel', false);
			},
			onConfirm() {
				this.$emit('update:show', false); //触发 input 事件，并传入新值
				this.$emit('handleConfirm', false);
			},
		},
	};
</script>

<style lang="less" scoped>
	.system-confirm {
		position:relative;
		/deep/ .van-popup {
			width: 361px;
			background: none;
			margin: 0 7px;

		}
		/deep/ .van-action-sheet__gap{
			height: 7px;
			background: none;
		}
		/deep/ .van-action-sheet__cancel {
			height: 55px;
			border-radius:12px;
			font-size: 18px;
			color: #007AFF;
		}
		/deep/ .van-action-sheet__content {
			background: white;
			border-radius:12px;
		}
		/deep/ .van-popup--bottom{
			bottom: 10px;
		}
		.content {
			.content-text {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 55px;
				padding: 0;
				font-size: 12px;
				line-height: 12px;
				color: #888888;
				border-bottom: 1px solid #CCCCCC;
			}
			.content-btn {
				display: block;
				width: 100%;
				height: 55px;
				padding: 0;
				font-size: 18px;
				line-height: 20px;
				background-color: #fff;
				border: none;
				cursor: pointer;
				border-radius: 0 0 12px 12px;
			}
			.confirm {
				color: #FE0000;
			}
		}
	}
</style>
